import { cn } from '@utils/cn';
import { SchedulerBlockProps } from './types';

export const SchedulerBlock = ({ title, className, children, ...props }: SchedulerBlockProps) => (
  <section className={cn('shrink-0 bg-white px-4 py-3.5', className)} {...props}>
    {title && <h3 className="mb-2.5 text-base font-bold text-neutral-800">{title}</h3>}
    {children}
  </section>
);
